export default __webpack_public_path__ + "static/media/480_private01-es-mobile.e2f2944f.png";